import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import {
  addCustomerAPI,
  getCustomerAPI,
  deleteCustomerAPI,
  EditCustomerAPI,
  SingleCustomerAPI,
  getCustomerTypeAPI,
  addCustomerFollowupAPI,
  getCustomerFollowupAPI,
  getCustomerProfileAPI,
  updateCustomerProfileAPI,
  getCustomerNameAPI,
  uploadFileAPI,
  getUploadFileAPI,
  createUploadFileLinkAPI,
  uploadFileLinkAPI,
  custViewFilesAPI,
  deleteFileAPI,
  getBlockedCustAPI,
  editCustFilesAPI
} from "./api"
import {
  addCustomerSuccess,
  addCustomerFailure,
  getCustomerSuccess,
  getCustomerFailure,
  deleteCustomerSuccess,
  deleteCustomerFailure,
  editCustomerSuccess,
  editCustomerFailure,
  ViewCustomerSuccess,
  ViewCustomerFailure,
  CustomerTypeSuccess,
  CustomerTypeFailure,
  addCustomerFollowupSuccess,
  addCustomerFollowupFailure,
  getCustomerFollowupSuccess,
  getCustomerFollowupFailure,
  getCustomerProfileSuccess,
  getCustomerProfileFailure,
  updateCustomerProfileSuccess,
  updateCustomerProfileFailure,
  getCustomerNameSuccess,
  getCustomerNameFail,
  uploadFileSuccess,
  uploadFileFail,
  getUploadedFileSuccess,
  getUploadedFileFailure,
  createUploadLinkSuccess,
  createUploadLinkFail,
  uploadFileLinkSuccess,
  uploadFileLinkFail,
  custViewFilesSuccess,
  custViewFilesFail,
  deleteFileStart,
  deleteFileSuccess,
  deleteFileFailure,
  getBlockedCustSuccess,
  getBlockedCustFailed,
  editCustFilesSuccess,
  editCustFilesFailed
} from "./action"
import {
  ADD_CUSTOMER_START,
  GET_CUSTOMER_START,
  DELETE_CUSTOMER_START,
  EDIT_CUSTOMER_START,
  VIEW_CUSTOMER_START,
  GET_CUSTOMER_TYPE_START,
  ADD_CUSTOMER_FOLLOWUP_START,
  GET_CUSTOMER_FOLLOWUP_START,
  GET_CUSTOMER_PROFILE_START,
  UPDATE_CUSTOMER_PROFILE_START,
  GET_CUSTOMER_NAME_START,
  UPLOAD_FILE_START,
  GET_UPLOADED_FILE_START,
  CREATE_UPLOAD_LINK_START,
  UPOLOAD_FILE_LINK_START,
  CUST_VIEWFILE_START,
  DELETE_FILE_START,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  GET_BLOCKED_CUST,
  EDIT_CUST_FILES
} from "./actiontypes"

function* addCustomerAsync(action) {
  try {
    const response = yield call(addCustomerAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(addCustomerSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(addCustomerFailure(error.response.data))
  }
}
function* AddCustomer() {
  yield takeEvery(ADD_CUSTOMER_START, addCustomerAsync)
}

function* getCustomerNameAsync(action) {
  try {
    const response = yield call(getCustomerNameAPI, action.payload);
    // console.log(response.data);

    if (response.status === 200) {
      yield delay(500); // Assuming you have a delay function available
      yield put(getCustomerNameSuccess(response.data));
      // console.log(response.data);
    } else {
      yield put(getCustomerNameFail(response.data));
    }
  } catch (error) {
    yield put(getCustomerNameFail(error.response.data));
  }
}

function* getCustomerName() {
  yield takeEvery(GET_CUSTOMER_NAME_START, getCustomerNameAsync)
}

function* getCustomerAsync(action) {
  try {
    const response = yield call(getCustomerAPI, action.payload)
    if (response.status === 200) {
      delay(500)
      yield put(getCustomerSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getCustomerFailure(error.response.data))
  }
}

function* GetCustomer() {
  yield takeEvery(GET_CUSTOMER_START, getCustomerAsync)
}

function* deleteCustomerAsync(action) {
  try {
    const response = yield call(deleteCustomerAPI, action)
    if (response.status === 200) {
      yield put(deleteCustomerSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(deleteCustomerFailure(error.response.data))
  }
}

function* DeleteCustomer() {
  yield takeEvery(DELETE_CUSTOMER_START, deleteCustomerAsync)
}

function* editCustomerAsync(action) {
  try {
    const response = yield call(EditCustomerAPI, action.payload)
    if (response.status === 200) {
      yield put(editCustomerSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(editCustomerFailure(error.response.data))
    console.log(error.message)
  }
}

function* EditCustomer() {
  yield takeEvery(EDIT_CUSTOMER_START, editCustomerAsync)
}

//view-customer

function* SingleCustomerAsync(action) {
  try {
    const response = yield call(SingleCustomerAPI, action.payload)
    if (response.status === 200) {
      yield put(ViewCustomerSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(ViewCustomerFailure(error.response.data))
  }
}

function* SingleCustomer() {
  yield takeEvery(VIEW_CUSTOMER_START, SingleCustomerAsync)
}

// Customer Type API :
function* getCustomerTypeAsync(action) {
  try {
    const response = yield call(getCustomerTypeAPI, action.payload)
    if (response.status === 200) {
      yield put(CustomerTypeSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(CustomerTypeFailure(error.response.data))
  }
}

function* GetCustomerType() {
  yield takeEvery(GET_CUSTOMER_TYPE_START, getCustomerTypeAsync)
}

function* addCustomerFollowupAsync(action) {
  try {
    const response = yield call(addCustomerFollowupAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(addCustomerFollowupSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(addCustomerFollowupFailure(error.response.data))
  }
}
function* addCustomerFollowup() {
  yield takeEvery(ADD_CUSTOMER_FOLLOWUP_START, addCustomerFollowupAsync)
}

function* getCustomerFollowupAsync(action) {
  try {
    const response = yield call(getCustomerFollowupAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(getCustomerFollowupSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getCustomerFollowupFailure(error.response.data))
  }
}
function* getCustomerFollowup() {
  yield takeEvery(GET_CUSTOMER_FOLLOWUP_START, getCustomerFollowupAsync)
}

function* getCUstomerProfileAsync(action) {
  try {
    const response = yield call(getCustomerProfileAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(getCustomerProfileSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(getCustomerProfileFailure(error.response.data))
  }
}
function* getCustomerProfile() {
  yield takeEvery(GET_CUSTOMER_PROFILE_START, getCUstomerProfileAsync)
}

function* updateCustomerProfileAsync(action) {
  try {
    const response = yield call(updateCustomerProfileAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(updateCustomerProfileSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(updateCustomerProfileFailure(error.response.data))
  }
}
function* updateCustomerProfile() {
  yield takeEvery(UPDATE_CUSTOMER_PROFILE_START, updateCustomerProfileAsync)
}

function* uploadFileAsync(action){
  try {
    const response = yield call(uploadFileAPI, action.payload)
    if(response.status === 200 || response.status === 201){
      yield put(uploadFileSuccess(response.data.message))
    } else {
      throw response;
    }
  } catch (error) {
    console.error("Upload file error:", error?.response || error)
    const msg = error?.response?.data?.message || "Unable to upload files"
    yield put(uploadFileFail(msg))
  }
}

function* uploadFiles(){
  yield takeEvery(UPLOAD_FILE_START, uploadFileAsync)
}

function* getUploadedFilesAsync(action){
  try {
    const response = yield call(getUploadFileAPI, action.payload)
    // console.log(response)
    if(response.status === 200 || 201){
      yield put(getUploadedFileSuccess(response.data))
    }else{
      throw response;
    }
  } catch (error) {
    yield put(getUploadedFileFailure(error.response.data.message))
  }
}

function* getUploadedFiles(){
  yield takeEvery(GET_UPLOADED_FILE_START, getUploadedFilesAsync)
}


function* createUploadFileLinkAsync(action){
  try {
    const response = yield call(createUploadFileLinkAPI, action.payload)
    // console.log(response)
    if(response.status === 200 || 201){
      console.log(response)
      yield put(createUploadLinkSuccess(response.data))
    }else{
      throw response;
    }
  } catch (error) {
    yield put(createUploadLinkFail(error.response.data.message || "Unable To Upload File Please Try Again"))
  }
}

function* createUploadFileLink(){
  yield takeEvery(CREATE_UPLOAD_LINK_START, createUploadFileLinkAsync)
}



function* uploadFileLinkStartAsync(action){
  try {
    const response = yield call(uploadFileLinkAPI, action.payload)
    // console.log(response)
    if(response.status === 200 || 201){
      console.log(response)
      yield put(uploadFileLinkSuccess(response.data))
    }else{
      throw response;
    }
  } catch (error) {
    yield put(uploadFileLinkFail(error.response.data.message || "Unable To Upload File Please Try Again"))
  }
}

function* uploadFileLinkStart(){
  yield takeEvery(UPOLOAD_FILE_LINK_START, uploadFileLinkStartAsync)
}

function* custViewFilesAsync(action) {
  try {
    const response = yield call(custViewFilesAPI, action.payload)
    // correct check for HTTP status
    if (response && (response.status === 200 || response.status === 201)) {
      // put the full response.data so reducer can use user/files/policies
      yield put(custViewFilesSuccess(response.data))
    } else {
      // create an error message if shape unexpected
      const msg = (response && response.data && response.data.message) || "Unable to fetch files"
      yield put(custViewFilesFail(msg))
    }
  } catch (error) {
    // defensive: error.response may be undefined
    const errMsg =
      (error && error.response && (error.response.data && error.response.data.message)) ||
      (error && error.message) ||
      "Something went wrong"
    yield put(custViewFilesFail(errMsg))
  }
}

function* custViewFiles(){
  yield takeEvery(CUST_VIEWFILE_START, custViewFilesAsync)
}

function* deleteFileAsync(action) {
  console.log(action.payload)
  try {
    const response = yield call(deleteFileAPI, action.payload)
    if (response.status === 200) {
      yield put(deleteFileSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(deleteFileFailure(error.response.data))
  }
}

function* DeleteFile() {
  yield takeEvery(DELETE_FILE_START, deleteFileAsync)
}



function* getBlockedCustAsync(action) {
  console.log(action.payload)
  try {
    const response = yield call(getBlockedCustAPI, action.payload)
    if (response.status === 200) {
      yield put(getBlockedCustSuccess(response.data.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getBlockedCustFailed(error?.response?.data.message||"Something unexpected error occured, please try again"))
  }
}

function* getBlockedCust() {
  yield takeEvery(GET_BLOCKED_CUST, getBlockedCustAsync)
}



function* editCustFilesAsync(action) {
  console.log(action.payload)
  try {
    const response = yield call(editCustFilesAPI, action.payload)
    if (response.status === 200) {
      yield put(editCustFilesSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(editCustFilesFailed(error?.response?.data.message||"Something unexpected error occured, please try again"))
  }
}

function* editCustFiles() {
  yield takeEvery(EDIT_CUST_FILES, editCustFilesAsync)
}

function* CustomerSaga() {
  yield all([
    fork(AddCustomer),
    fork(GetCustomer),
    fork(DeleteCustomer),
    fork(EditCustomer),
    fork(SingleCustomer),
    fork(GetCustomerType),
    fork(addCustomerFollowup),
    fork(getCustomerFollowup),
    fork(getCustomerProfile),
    fork(updateCustomerProfile),
    fork(getCustomerName),
    fork(uploadFiles),
    fork(getUploadedFiles),
    fork(createUploadFileLink),
    fork(uploadFileLinkStart),
    fork(custViewFiles),
    fork(DeleteFile),
    fork(getBlockedCust),
    fork(editCustFiles),
  ])
}
export default CustomerSaga
